import { observable, action } from "mobx";
import type { BlockFragment } from "../../app/core/generated/webapi.g";

export class Block {
    @observable
    currentBlock?: BlockFragment;

    constructor(currentBlock?: BlockFragment) {
        this.currentBlock = currentBlock;
    }

    @action
    storeBlock = (block: BlockFragment) => {
        this.currentBlock = block;
    };
}
